// src/state/selectors/register/index.ts
var selectSpecialsCounterValue = (state) => state.register.specialsCounter;
var selectIsEndOfDayActive = (state) => state.register.endOfDay.isEndOfDayActive;
var selectCustomizer = (state) => state.register.customizer;

export { selectCustomizer, selectIsEndOfDayActive, selectSpecialsCounterValue };
